import ungroupedRoutesData from "../../const/RoutesList";

const SaveLastVisitedPages = (currentPage, prefix) => {
    const localStorageKey = `${prefix}-visitedPages`;
    const validRoutes = ungroupedRoutesData.map((route) => route.value);
    let isValid=validRoutes.includes(currentPage);
    if (currentPage === "/home" || !isValid)
        return;
    const savedPages = JSON.parse(localStorage.getItem(localStorageKey)) || [];
    const updatedPages = savedPages.filter((page) => page !== currentPage);
    updatedPages.unshift(currentPage);
    const lastFivePages = updatedPages.slice(0, 5);
    localStorage.setItem(localStorageKey, JSON.stringify(lastFivePages));
};

export default SaveLastVisitedPages;